module.exports = __webpack_public_path__ + "static/media/Resume.698f2376.pdf";